import { Env } from '@env';
// `@sentry/react` is available transitively via `@sentry/react-native` (a hard
// dep), so we don't list it directly. Native and web each pick the SDK that's
// right for the platform via Metro's `index.ts` / `index.native.ts` resolution.
import * as Sentry from '@sentry/react';

const DSN =
  'https://b411ae723452981568c1704688e15e6b@o4505862326714368.ingest.us.sentry.io/4508055041343488';

export function initSentry() {
  const c = Sentry.init({
    dsn: DSN,
    environment: Env.APP_ENV,
    // Match what `@sentry/react-native` reports on web so the same release
    // ties together events and the source maps already uploaded by Vercel.
    release: `${Env.NAME}@${Env.VERSION}`,
  });
}

export { Sentry };
